import React from 'react'
import { G, Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const NotificationsEmptyIcon = createIcon({
    viewBox: '0 0 32 32',
    path: (
        <G transform='scale(2) translate(-3.5, -4)'>
            <Path
                fill='currentColor'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.73 15.926V11.006C14.7382 10.3618 14.6054 9.72353 14.341 9.136C14.1049 8.59972 13.72 8.14233 13.232 7.818C12.739 7.477 12.162 7.306 11.5 7.306C10.838 7.306 10.261 7.476 9.768 7.818C9.288 8.133 8.918 8.572 8.658 9.137C8.39359 9.72453 8.26083 10.3628 8.269 11.007V15.927H14.731L14.73 15.926ZM16.365 15.08L18 16.733V17.54H5V16.733L6.635 15.08V11.006C6.635 9.72 6.953 8.612 7.588 7.68C8.237 6.722 9.138 6.1 10.293 5.81V5.24C10.293 4.899 10.41 4.607 10.643 4.364C10.877 4.121 11.163 4 11.5 4C11.837 4 12.126 4.121 12.366 4.364C12.606 4.607 12.726 4.899 12.726 5.24V5.81C13.868 6.1 14.763 6.729 15.412 7.7C16.047 8.631 16.365 9.733 16.365 11.006V15.08ZM11.5 20C11.059 20 10.676 19.843 10.352 19.528C10.1957 19.3821 10.0716 19.2052 9.98772 19.0085C9.90385 18.8118 9.86205 18.5998 9.865 18.386H13.135C13.135 18.832 12.973 19.213 12.648 19.528C12.4979 19.6795 12.319 19.7993 12.1218 19.8803C11.9246 19.9614 11.7132 20.0021 11.5 20Z'
            />
        </G>
    ),
})

NotificationsEmptyIcon.displayName = 'NotificationsEmptyIcon'
